import React from 'react';

const Footer = () => (
  <footer className='bg-dark-orange py-1 pl-4'>Sean Philippi © {new Date().getFullYear()}</footer>
);

export default Footer;